import React, { useEffect, useRef, useState } from "react";
import {
  avatar,
  img_placehlder,
  msg_frst_prson,
  removemember_dp,
} from "../../../../assets";
import { BsFillSendFill, BsThreeDots } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import { GoChevronRight } from "react-icons/go";
import { useSelector } from "react-redux";
import { socket } from "../../../../utils/socket";
import { useNavigate } from "react-router";
import { LoadingButton, TextArea } from "../../../../Components/header/form";
import CustomModal from "../../../../Components/modals/CustomModal";
import { IoImage, IoMenu } from "react-icons/io5";
import moment from "moment";
import { uploadAttachmentApi } from "../../../../services/message";
import { toastMessage } from "../../../../utils/toastMessage";
import FileUpload from "./FileUpload";
import OverviewReport from "../../Overview/section/OverviewReport";
import ViewProfile from "./ViewProfile";
import { chatRequestApi } from "../../../../services/groupMember";
import RightSideMessage from "../groupMessages/RightSideMessage";
import LeftSideMessage from "../groupMessages/LeftSideMessage";
import { CiCircleRemove } from "react-icons/ci";
import { previewFiles } from "../groupMessages/commonMessage";

const MembersChat = ({
  selectedChat,
  chatMessage,
  fetchMessages,
  chatContainerRef,
  setChatMessage,
  receiverData,
  currentPage,
  setCurrentPage,
  totalPages,
  memberDetails,

  isReplay,
  setIsReplay,
  selectedReplyData,
  setSelectReplyData,
}) => {
  // console.log("selectedChat", selectedChat);
  // console.log('memberDetails', memberDetails)
  const navigate = useNavigate();
  const messageRefs = useRef({});
  const chatEndRef = useRef(null);
  const replyRef = useRef(null)
  const chatInputRef = useRef(null)
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [inputData, setInputData] = useState({ message: "", type: "" });
  const [attachment, setAttachment] = useState({
    attachment: "",
    type: "",
    url: "",
  });
  // console.log('inputData', inputData)
  const [file, setFile] = useState({ attachment: "" });
  const [imageModal, setImageModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [imageButtonLoader, setImageButtonLoader] = useState(false)
  const [viewProfileUrl, setViewProfileUrl] = useState('')
  const [viewProfileModal, setViewProfileModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [highlightMsg, setHighlightMsg] = useState(false)
  //-----------handle-Is-Reply-----------------
  const handleIsReply = () => {
    setIsReplay(false)
    setSelectReplyData({})
  }
  //----------handle-report-------------
  const handleReport = (data) => {
    setSelectedData(data);
    setReportModal(true);
  };
  //----------handle-report-------------
  const handleViewProfile = (image) => {
    if (image) {
      setViewProfileUrl(image);
      setViewProfileModal(true);
    }
  };
  // Send Request To Other Users
  const sendChatRequestHandler = async (id) => {
    try {
      setLoading(true);
      const { data } = await chatRequestApi({ _user: id });
      const { success, message } = data;
      toastMessage(message, success ? "success" : "error", "acceptRejectMember");
      if (success) {
        // fetchMemberDetail();
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  //------------------------------
  const handleAcceptRejectEmit = (type) => {
    socket.emit("REQUEST_UPDATE_CHAT_REQUEST", {
      _id: receiverData?._id,
      status: type,
    });
  };

  useEffect(() => {
    socket.on("RECEIVE_UPDATE_CHAT_REQUEST", (data) => {
      navigate("/dashboard/message");
    });
  }, []);

  const receiveMessage = (data) => {
    const { success, data: response } = data;
    // console.log(response,"particular data i m getting");
    if (success) {
      setChatMessage((prev) => [...prev, response]);
    }
  };

  // Receive Chat List
  useEffect(() => {
    socket.on("RECEIVE_MESSAGE", receiveMessage);

    return () => {
      socket.off("RECEIVE_MESSAGE", receiveMessage);
    };
  }, []);

  //-----------press-enter-send-message-------------------
  const onEnterPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (attachment?.attachment) {
        sendDataHandler(attachment);
      }
      else if (inputData?.message.trim()) {
        sendDataHandler(inputData.message);
        setInputData({ ...inputData, message: "" });
      }
    } else if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setInputData({
        ...inputData,
        message: inputData?.message + "\n",
      });
    }
  };
  //---------send-message---------------
  const sendDataHandler = (attachment) => {
    // console.log('attachment in member', attachment)
    let sendData = {};
    const uploadedUrl = attachment?.attachment || '';
    const fileExtension = uploadedUrl.split('.').pop().toLowerCase();

    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
    const isPDF = fileExtension === 'pdf';

    const hasMessage = inputData?.message?.trim();
    const hasAttachment = attachment?.attachment;

    // CASE 1: Text + Attachment
    if (hasMessage && hasAttachment) {
      sendData = {
        attachments: [{
          type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
          url: attachment.attachment
        }],
        message: hasMessage,
        type: "BOTH"
      };
    }
    // CASE 2: Only Attachment (Image or PDF)
    else if (!hasMessage && hasAttachment) {
      sendData = {
        attachments: [{
          type: isImage ? "IMAGE" : isPDF ? "DOCUMENTS" : "UNKNOWN",
          url: attachment.attachment
        }],
        type: attachment.type || "MEDIA"
      };
    }
    // CASE 3: Only Text
    else if (hasMessage && !hasAttachment) {
      sendData = {
        message: hasMessage,
        type: inputData.type || "TEXT"
      };
    }
    if (Object.keys(sendData).length === 0) {
      toastMessage("No data to send.", "error", "sendData");
      return;
    }
    socket.emit("SENT_MESSAGE", {
      _chat: selectedChat?._id,
      ...(isReplay ? { replyOf: selectedReplyData?._id } : {}), // Conditionally add replyOf
      ...sendData,
    });
    setInputData({ message: "", type: "" });
    setAttachment({ attachment: "", type: "", url: "" });
    setFile({ attachment: '' });
    setIsReplay(false)
    setSelectReplyData({})
  };

  //   Load More older message
  const loadMoreMessages = () => {
    const chatContainer = chatContainerRef.current;
    if (chatContainer.scrollTop === 0 && totalPages > currentPage) {
      fetchMessages(currentPage + 1);
      setCurrentPage((prev) => prev + 1);
    }
  };
  // Scroll to the bottom whenever chatMessage changes (new messages)
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessage]);

  //----------image-past-handler-----------------
  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items;
    for (let item of clipboardItems) {
      if (item.type.startsWith("image/")) {
        const file = item.getAsFile();
        setFile({ attachment: file });
        // Automatically upload the pasted image
        uploadAttachment(file);
        break;
      }
    }
  };
  //-----------image-create-url---------------
  const uploadAttachment = async (pastedFile) => {
    if (!pastedFile) {
      return toastMessage("Please upload an image", "error", "selectMedia");
    }
    try {
      setImageButtonLoader(true);
      const formData = new FormData();
      formData.append("attachments", pastedFile);

      const { data } = await uploadAttachmentApi(formData);
      const { success, message, data: res } = data;

      if (success) {
        setAttachment({
          attachment: res?.[0]?.key,
          url: res?.[0]?.url,
          type: "MEDIA"
        })
        setInputData({ message: "", type: "" })
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setImageButtonLoader(false);
    }
  };

  useEffect(() => {
    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);
  // Check if attachment exists and focus on the chat input div
  useEffect(() => {
    if (attachment?.attachment && chatInputRef.current) {
      chatInputRef.current.focus();
    }
  }, [attachment?.attachment])

  //---------scroll-reply-message-----------------------
  const scrollToMessage = (messageId) => {
    if (messageRefs.current[messageId]) {
      // Scroll to the message
      messageRefs.current[messageId].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Highlight the message
      const messageElement = messageRefs.current[messageId];
      messageElement.classList.add("highlight-message");
      // setHighlightMsg(true)
      // Remove the highlight after 2 seconds
      setTimeout(() => {
        messageElement.classList.remove("highlight-message");
        // setHighlightMsg(false)
      }, 2000);
    }
  };
  // // Check if attachment exists and focus on the chat input div
  useEffect(() => {
    if (attachment?.attachment && chatInputRef.current) {
      chatInputRef.current.focus();
    } else if (selectedReplyData?._id && chatInputRef.current) {
      replyRef?.current?.focus();
    }
  }, [attachment?.attachment, selectedReplyData?._id])
  return (
    <>
      {/* ---------------invitation-sent---------------------- */}
      {receiverData?._receiver &&
        receiverData?._receiver?._id !== showAuth?._id &&
        receiverData?.status === "REQUESTED" && (
          <div className="chatting">
            <div className="chat-header">
              <div className="avatar">
                <img
                  src={memberDetails?._user?.profilePicture || selectedChat?.chatParticipants?._user?.profilePicture || img_placehlder}// 
                />
              </div>
              <div className="text-content">
                <div className="title">
                  {memberDetails?._user?.fullName || selectedChat?.chatParticipants?._user?.fullName}
                </div>
                <div className="memberss">
                  Group:{" "}
                  {memberDetails?._group?.name || selectedChat?.chatParticipants?.groupMember?.group?.name}
                </div>
              </div>
            </div>

            <div className="chatting">
              <div className="acceptance_wrap">
                <p>
                  Invitation Sent..{" "}
                  <span className="cstm_span">
                    {" "}
                    Waiting for accept invitation
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
      {/* --------------send-invitation----------------------- */}
      {!receiverData?._receiver && selectedChat?.chatExist === false && (
        <div className="chatting">
          <div className="chat-header">
            <div className="avatar">
              <img
                src={memberDetails?._user?.profilePicture || img_placehlder} />
            </div>

            <div className="text-content">
              <div className="title">
                {memberDetails?._user?.fullName || selectedChat?.chatParticipants?._user?.fullName}
              </div>
              <div className="memberss">
                Group:{" "}
                {memberDetails?._group?.name || selectedChat?.chatParticipants?.groupMember?.group?.name}
              </div>
            </div>
          </div>

          <div className="chatting">
            <div className="acceptance_wrap">
              <p>
                Do you want to send an invitation?{" "}
                <span className="cstm_span">
                  <LoadingButton
                    loading={loading}
                    onClick={() => sendChatRequestHandler(selectedChat?._user)}
                  >
                    send chat invitation
                  </LoadingButton>
                </span>
              </p>
            </div>
          </div>
        </div>
      )}
      {/* ---------------Accept-and-reject---------------------- */}
      {receiverData?._receiver &&
        receiverData?._receiver?._id === showAuth?._id &&
        receiverData?.status === "REQUESTED" && (
          <div className="chatting">
            <div className="chat-header">
              <div className="avatar">
                <img
                  src={selectedChat?.chatParticipants?._user?.profilePicture || img_placehlder} />
              </div>
              <div className="text-content">
                <div className="title">
                  {selectedChat?.chatParticipants?._user?.fullName}
                </div>
                <div className="memberss">
                  Group:{" "}
                  {selectedChat?.chatParticipants?.groupMember?.group?.name}
                </div>
              </div>
            </div>
            <div className="chatting">
              <div className="acceptance_wrap">
                <button className="me-3 " onClick={() => handleAcceptRejectEmit("ACCEPT")}>
                  Accept
                </button>
                <button onClick={() => handleAcceptRejectEmit("REJECT")}>
                  Reject
                </button>
              </div>
            </div>
          </div>

        )}
      {/* ---------------one-to-one-chat---------------------- */}
      {!receiverData && selectedChat?.chatExist !== false && (
        <div className="chatting">
          <div className="chat-header">
            <div className="avatar" onClick={() => handleViewProfile(selectedChat?.chatParticipants?._user?.profilePicture)}>
              <img src={memberDetails?._user?.profilePicture || selectedChat?.chatParticipants?._user?.profilePicture || img_placehlder} />
            </div>
            <div className="text-content">
              <div className="title">
                {memberDetails?._user?.fullName || selectedChat?.chatParticipants?._user?.fullName}
              </div>
              <div className="memberss">
                Group:{" "}
                {memberDetails?._group?.name || selectedChat?.chatParticipants?.groupMember?.group?.name}
              </div>
            </div>
            {/* <div className="menu-button">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <BsThreeDots />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">
                    Another action
                  </Dropdown.Item>
                  <Dropdown.Item href="#/action-3">
                    Something else
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
          </div>

          <div
            className="chat-messages"
            ref={chatContainerRef}
            onScroll={loadMoreMessages}
          >
            {/* {chatMessage &&
              chatMessage
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                .map((data, ind) => {
                  if (data?._sender?._id === showAuth?._id) {
                    return (
                      <div className="unique_message_box" key={ind}>
                        <div className="message-sender"
                          onClick={() => handleViewProfile(data?.attachments?.[0]?.url)}
                        >
                          {data?.type === "MEDIA" ? (
                            <img
                              className="w-50"
                              src={data?.attachments?.[0]?.url}
                              alt=""
                            />
                          ) : (
                            <p className="msg-text">{data?.message || ""}</p>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="msg-item" key={data._id}>
                        <div className="msg-avatar">
                          <img
                            className=""
                            src={data?._sender?.profilePicture || avatar}
                            alt="Avatar"
                          />
                        </div>
                        <div className="msg-content">
                          <div className="msg-header">
                            <span className="msg-name">
                              {data?._sender?.fullName}
                            </span>
                            <span className="msg-time">
                              {moment(data?.createdAt).fromNow()}
                            </span>
                          </div>
                          {data?.type === "MEDIA" ? (
                            <>
                              <div className="msg-text_wrap">
                                <div className="msg-text"
                                  onClick={() => handleViewProfile(data?.attachments?.[0]?.url)}
                                >
                                  <img
                                    src={data?.attachments?.[0]?.url}
                                    alt=""
                                  />
                                </div>
                                <div className="three-dotss">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <BsThreeDots />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => handleReport(data)}
                                      >
                                        Report
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="msg-text_wrap">
                                <div className="msg-text">
                                  <span>{data?.message || ""}</span>
                                </div>
                                <div className="three-dotss">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                    >
                                      <BsThreeDots />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => handleReport(data)}
                                      >
                                        Report
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  }
                })} */}
            {chatMessage &&
              chatMessage
                .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) // Sort the messages by date
                .map((data, ind) => {
                  return (
                    <div
                      key={data._id}
                      ref={(el) => {
                        if (el) messageRefs.current[data._id] = el;
                      }}
                    >
                      {data?._sender?._id === showAuth?._id ? (
                        <RightSideMessage
                          {...{
                            data,
                            ind,
                            handleViewProfile,
                            scrollToMessage,
                            highlightMsg,
                            setIsReplay,
                            setSelectReplyData,
                          }}
                        />
                      ) : (
                        <LeftSideMessage
                          {...{
                            data,
                            handleViewProfile,
                            setIsReplay,
                            setSelectReplyData,
                            scrollToMessage,
                            highlightMsg
                          }}
                        />
                      )}
                    </div>
                  );
                })}
            <div ref={chatEndRef} />
          </div>
          {/* --------send-message--input--------------- */}
          {/* {(isReplay || attachment?.url) && (
            <div className="isReply img_reply">
              {isReplay ? (
                <>
                  <button type="button" className="remove" onClick={handleIsReply}>
                    <CiCircleRemove />
                  </button>
                  <div className="reply_text">
                    <b className="user_name">
                      {selectedReplyData?._sender?.fullName}
                    </b>

                    {selectedReplyData?.message && (
                      <p>{selectedReplyData.message}</p>
                    )}

                    {selectedReplyData?.attachments?.length > 0 &&
                      selectedReplyData.attachments[0]?.url &&
                      previewFiles(selectedReplyData.attachments[0].url)}
                  </div>
                </>
              ) : (
                <div className="reply_text post_img">
                  {previewFiles(attachment.url)}
                </div>
              )}
            </div>
          )} */}

          <div className="isReply img_reply">
            {isReplay && (
              <>
                <button type="button" className="remove" onClick={handleIsReply}>
                  <CiCircleRemove />
                </button>
                <div className="reply_text">
                  <b className="user_name">
                    {selectedReplyData?._sender?.fullName}
                  </b>

                  {selectedReplyData?.message && (
                    <p>{selectedReplyData?.message}</p>
                  )}
                  {selectedReplyData?.attachments.length > 0 && (
                    previewFiles(selectedReplyData?.attachments?.[0]?.url)
                  )}
                </div>
              </>
            )}
            {attachment?.url && (
              <div className="reply_text post_img">
                {previewFiles(attachment?.url)}
              </div>
            )}
          </div>

          <div
            className="chat-input"
            tabIndex={0}
            onKeyDown={onEnterPress}
            ref={chatInputRef}
          >
            <TextArea
              type="text"
              ref={replyRef}
              // disabled={attachment?.attachment}
              className="input-field"
              value={inputData?.message || ""}
              placeholder={attachment?.url ? 'Add Caption...' : 'Write message here...'}
              name="message"
              onChange={(e) =>
                setInputData({
                  ...inputData,
                  message: e.target.value,
                  type: "TEXT",
                })
              }
            // onKeyDown={onEnterPress}
            />
            <IoImage
              className="input_inside_img"
              // className={`input_inside_img ${attachment?.url ? 'text-primary' : ''}`}
              onClick={() => setImageModal(true)}
            />
            <button
              className="send-button"
              // className={`send-button ${attachment?.url ? 'text-primary' : ''}`}
              // disabled={!inputData?.message && !attachment?.attachment}
              disabled={(!inputData?.message && !attachment?.attachment) || imageButtonLoader}
              onClick={() => sendDataHandler(attachment)}
            >
              <BsFillSendFill />
            </button>
          </div>
        </div>
      )}
      {/* -------image-upload-------------- */}
      <FileUpload
        show={imageModal}
        close={() => setImageModal(false)}
        attachment={attachment}
        setAttachment={setAttachment}
        file={file}
        setFile={setFile}
        sendDataHandler={sendDataHandler}
      />
      {/* ---------report--------------------- */}
      <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={null}
        id={selectedData?._id}
        pageName="Message"
        type="MESSAGE"
      />
      {/* -------view-profile-image-------------- */}
      <ViewProfile
        show={viewProfileModal}
        close={() => setViewProfileModal(false)}
        profileUrl={viewProfileUrl}
      />
    </>
  );
};

export default MembersChat;
